import { createStore as createVuexStore, StoreOptions } from 'vuex';

import { env } from '@/constants/env';
import { RootState } from '@/models/vuex/rootState';

import cart from './cart';
import CRM from './CRM';
import order from './orders/';
import S2S from './S2S/';

export function getVuexStoreConfig(): StoreOptions<RootState> {
  return {
    strict: env.MODE !== 'production',
    modules: {
      cart,
      CRM,
      order,
      S2S,
    },
  };
}

export function createStore() {
  return createVuexStore(getVuexStoreConfig());
}
